export const INIT_STORES = 'INIT_STORES';
export const INIT_CITIES = 'INIT_CITIES';